import { useQuery } from 'react-query';
import { errorHandler } from 'App/utils';
import PESService from '../services/PESService';

/*
fetch list of diagnosis based on therapy id
 */
function useFetchDiagnosisQuery(therapyId) {
    return useQuery(['therapyId', therapyId, 'diagnosis'], () => PESService.getDiagnosis(therapyId), {
        onError: (error) => {
            errorHandler(error);
        },
        enabled: !!therapyId,
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });
}

export default useFetchDiagnosisQuery;
